import { useContext } from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';

import { Routes } from 'types/routes';

import LocaleContext from 'components/context/Locale';
import Head from 'components/layout/Head';
import LayoutContainer from 'components/layout/LayoutContainer';
import PageContainer from 'components/layout/PageContainer';
import LayoutDefault from 'components/modules/public/layouts/Default';

import Contact from './sections/Contact';
import Content from './sections/Content';
import SearchSection from './sections/Search';
import StyledComponent from './styles';
import { Props } from './types';

const PublicPageFaq: NextPage<Props> = ({ faqCategories, faqPosts, cmsPage }) => {
    const router = useRouter();
    const localeContext = useContext(LocaleContext);
    const data = localeContext?.translations?.faq;

    const onSearch = (search: string) => {
        router.push({
            pathname: Routes.PublicFaq,
            query: { search },
        });
    };

    return (
        <StyledComponent className="public-page-faq">
            <Head
                {...data.meta}
                title={cmsPage?.metaTitle || data?.meta?.title}
                description={cmsPage?.metaDescription || data?.meta?.description}
                robots={cmsPage?.metaRobots}
                image={cmsPage?.image?.imageUrl || data?.meta?.image}
            />
            <LayoutDefault>
                <PageContainer>
                    <LayoutContainer>
                        <SearchSection
                            {...data.content.form}
                            initialValues={{
                                search: router.query?.search?.toString(),
                            }}
                            onSuccess={onSearch}
                        />
                        <div className="content">
                            <Content
                                {...data.content.questions}
                                categories={faqCategories}
                                posts={faqPosts}
                            />
                            <Contact {...data.content.contact} />
                        </div>
                    </LayoutContainer>
                </PageContainer>
            </LayoutDefault>
        </StyledComponent>
    );
};

export default PublicPageFaq;
